import styled from "styled-components/macro";
import { themeVariables } from "../../themeVariables";

export const Container = styled.div`
  box-sizing: border-box;
  div {
    box-sizing: border-box;
  }
  width: 100%;
  color: ${themeVariables.grey0};
  background-color: ${themeVariables.menuColorFullscreen} !important;
  border: 1px solid ${themeVariables.grey3};
  &:focus-within {
    border-color: ${themeVariables.primaryCTAHighContrast};
  }
  border-radius: 5px;
  padding: 10px 10px 10px 32px;
  outline: none;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: "Inter", sans-serif;
  line-height: 1.5;

  > div {
    outline: none;
    border-radius: 6px;
  }

  > div > div {
    outline: none;
  }

  ol {
    color: ${themeVariables.grey0};
    list-style-type: decimal !important;
    margin: 0;
    counter-reset: list-counter; /* Reset counter for nested lists */
    padding-left: 0;
  }

  li {
    list-style-position: outside;
    padding: 0;
    padding-bottom: 0.7em;
    display: list-item !important; /* Force list-item display */
    list-style: decimal !important; /* Ensure decimal numbers are used */
    &.is-empty {
      list-style: none !important;
      &::marker {
        color: transparent;
        display: block;
      }
      &::before {
        content: attr(data-placeholder);
        position: relative;
        top: 0;
        left: 0;
        pointer-events: none; /* prevents the pseudo-element from capturing the cursor */
        user-select: none; /* makes the text unselectable */
        color: ${themeVariables.grey2};
        white-space: pre-wrap;
        font-size: 16px;
        line-height: 1.6;
        font-weight: 500;
        display: block;
        margin-left: -1em;
      }
    }
  }
  li:last-child {
    padding-bottom: 0;
  }

  .ProseMirror-focused {
    li {
      &.is-empty {
        list-style: decimal !important;
        &::before {
          display: none;
        }
        &::marker {
          color: ${themeVariables.grey0};
        }
      }
    }
  }

  &.has-content {
    li {
      &.is-empty {
        list-style: decimal !important;
        &::before {
          display: none;
        }
      }
    }
  }

  #button-container-generate-scenes {
    margin-left: -1em;
  }
  #button-generate-scenes {
    margin-top: 0px !important;
  }
`;
